export default __webpack_public_path__ + "static/media/SK.41f3e0bf.svg";